import { Widget } from './form-widget.model';
import { parseLocalDateString } from '../helpers/date-utils';

export class FbEmrDemographicsWidget extends Widget {
  constructor(data?: any) {
    super(data);
    this.name = 'fb-emr-demographics';
    this.title = 'Demographics';

    if (!this.properties.text) {
      this.properties.text = { title: 'Header', value: 'Demographics' };
    }
    if (!this.properties.content) {
      this.properties.content = {
        title: 'Description',
        value: '',
        placeholder: 'Add a description or, leave blank',
      };
    }
    if (!this.properties.items) {
      this.properties.items = {};
    }
  }

  isValid() {
    if (!this.properties?.items?.value) {
      return true;
    }

    const items = this.properties.items.value;

    for (const item of items) {
      if (item.nested && item.items && Array.isArray(item.items)) {
        // Check nested items (Personal Information, Address, Contact Information)
        // Only validate if the category is visible and enabled
        if (item.visible !== false && item.value === true) {
          for (const field of item.items) {
            if (field.required === true && field.visible !== false) {
              const fieldValue = field.value;
              if (
                fieldValue === undefined ||
                fieldValue === null ||
                fieldValue === '' ||
                (typeof fieldValue === 'string' && fieldValue.trim() === '')
              ) {
                console.log('✌️ Demographics validation failed for required field:', field.title);
                return false;
              }
            }
          }
        }
      } else {
        // Check single fields (for backward compatibility or non-nested fields)
        if (item.required === true && item.visible !== false) {
          const itemValue = item.value;
          if (
            itemValue === undefined ||
            itemValue === null ||
            itemValue === '' ||
            (typeof itemValue === 'string' && itemValue.trim() === '')
          ) {
            console.log('✌️ Demographics validation failed for required field:', item.title);
            return false;
          }
        }
      }
    }

    return true;
  }

  getValidationErrors() {
    const errors = [];
    if (!this.properties?.items?.value) {
      return errors;
    }

    const items = this.properties.items.value;

    for (const item of items) {
      if (item.nested && item.items && Array.isArray(item.items)) {
        // Check nested items (Personal Information, Address, Contact Information)
        // Only validate if the category is visible and enabled
        if (item.visible !== false && item.value === true) {
          for (const field of item.items) {
            if (field.required === true && field.visible !== false) {
              const fieldValue = field.value;
              if (
                fieldValue === undefined ||
                fieldValue === null ||
                fieldValue === '' ||
                (typeof fieldValue === 'string' && fieldValue.trim() === '')
              ) {
                errors.push(`${field.title} is required`);
              }
            }
          }
        }
      } else {
        if (item.required === true && item.visible !== false) {
          const itemValue = item.value;
          if (
            itemValue === undefined ||
            itemValue === null ||
            itemValue === '' ||
            (typeof itemValue === 'string' && itemValue.trim() === '')
          ) {
            errors.push(`${item.title} is required`);
          }
        }
      }
    }

    return errors;
  }

  public getMetadata() {
    if (!this.properties?.items?.value) {
      return {};
    }

    const items = this.properties.items.value;
    const metadata: any = {};

    // Field mapping from form titles to backend field names
    const fieldMapping: { [key: string]: string } = {
      // Personal Information fields
      'First Name': 'first_name',
      'Last Name': 'last_name',
      'Middle Name': 'middle_name',
      Gender: 'gender',
      Birthday: 'birthday',
      // Address fields
      'Address 1': 'address1',
      'Address 2': 'address2',
      City: 'city',
      State: 'state',
      'Zip/Postal': 'postal',
      // Contact Information fields
      'Mobile Phone': 'work_phone',
      Email: 'email',
    };

    // Process all items and create a flat structure
    for (const item of items) {
      if (item.nested && item.items && Array.isArray(item.items)) {
        // Process nested items (Personal Information, Address, Contact Information)
        if (item.visible !== false && item.value === true) {
          for (const field of item.items) {
            if (field.visible !== false && field.value !== undefined && field.value !== null) {
              const fieldName = fieldMapping[field.title];
              if (fieldName !== 'middle_name' && !field.value) continue;
              if (fieldName) {
                let fieldValue = field.value;

                if (field.type === 'date' && fieldValue) {
                  fieldValue = parseLocalDateString(fieldValue);
                }

                metadata[fieldName] = fieldValue;
              }
            }
          }
        }
      }
    }

    return metadata;
  }
}
